import SidePanelHeader from "../components/SidePanelHeader"
import SidePanelSensitiveInfo from "../components/SidePanelSensitiveInfo"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelInfo from "../components/SidePanelInfo"
import SidePanelAuditTrail from "../components/SidePanelAuditTrail";
import { EntityNames } from "../../../../../enums/EntityNames";
import SidePanelBreadCrumb from "../components/SidePanelBreadCrumb";
import { useEffect, useState } from "react";
import { httpGet } from "../../../../../modules/Backend";
import { hasPermission } from "../../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../../modules/auth/Permissions/PermissionStrings";
import { usePermissions } from "../../../../../modules/auth/Permissions/PermissionContext"
import { RangesSchema } from "../../../entityComponents/Schemas/RangesSchema";
import ActionBar from "../actions/ActionBar";
import EditAction from "../actions/EditAction";
import { hasVisibleChildren } from "../../../entityComponents/Schema";


export default function SidePanelRanges({ data,  onViewPage }: any) {
    const navigate = useNavigate()
    const [location, setLocation] = useState<string>("")
    const permissionsContext = usePermissions();

    function viewEntity() {
        // Only navigate if there are visible children
        if (hasVisibleChildren(data.entityName, permissionsContext)) {
            Navigation.view.navigate(navigate, data.entityName, data.id, data)
        }
    }

    function viewEntityAndTab(tabName?: string) {
        // Only navigate if there are visible children
        if (hasVisibleChildren(data.entityName, permissionsContext)) {
            var indexOfTab = RangesSchema.children?.findIndex(x => x.entityName == tabName) ?? 0
            Navigation.view.navigate(navigate, data.entityName, data.id, data,indexOfTab )
        }
    }

    function getTitle() {
        if (data.code)
            return data.code

        if (data.rangeStart_Original)
            return `${data.rangeStart_Original} > ${data.rangeEnd_Original}`
    }

    async function getLocation() {
        const result = await httpGet(`api/${EntityNames.ranges}/location?id=${data.id}`)
        if (result?.data?.breadcrumb) {
            setLocation(result.data.breadcrumb)
        }
    }

    useEffect(() => {
        data.currentLocation ? setLocation(data.currentLocation) : getLocation()
    }, [data])

    return (<>
        {data &&
            <>
                {!onViewPage && <SidePanelHeader descriptor="Range " value={getTitle()} statuses={data.status} onClick={(() => { viewEntity() })} />}
                <ActionBar>
                    {hasPermission(permissionsContext.permissions!, PermissionTypes.write, PermissionConcerns.Manage_Range) && 
                        <EditAction id={data.id} entityName={data.entityName} parentEntityId={data.rangePackingBoxId} parentEntityName={EntityNames.packingBox} />}
                </ActionBar>
                <SidePanelInfo
                    values={[
                        { label: "Status", value: onViewPage ? data.status : undefined },
                        { label: "Start Year", value: `${data.yearStart ?? data.year}` },
                        { label: "End Year", value: `${data.yearEnd ?? data.year}` },
                        { label: "Account", value: data.accountName },
                        { label: "Prefix", value: data.prefix },
                        { label: "Type", value: data.type ?? data.materialType },
                    ]}
                />
                <SidePanelBreadCrumb descriptor="Current Location" value={location} />
                {
                    !onViewPage &&
                    hasPermission(permissionsContext.permissions!, PermissionTypes.read, PermissionConcerns.Inventory_Audit_Trails) &&
                    (<SidePanelAuditTrail entityName={EntityNames.ranges} id={data.id} viewFunction={() => viewEntityAndTab(EntityNames.audits)} />)
                }
                {hasPermission(permissionsContext.permissions!, PermissionTypes.read, PermissionConcerns.PII_Notes) ? <SidePanelSensitiveInfo descriptor="Notes" data={data} dataTarget="notes" /> : null}
            </>
        }
    </>)
}